import { EnvironmentProviders, Provider } from '@angular/core';

import { AutorizacaoService } from './autorizacao.service';

export function provideAutorizacao(): Array<Provider | EnvironmentProviders> {
  return [AutorizacaoService];
}
